import Vue from 'vue'

export default {
  getFinancialClubInfo ({ commit }) {
    return Vue.axios.get('financial-club').then(({data}) => commit('SET_FINANCIAL_CLUB_INFO', data))
  },
  saveFinancialClubInfo ({ commit, dispatch, state }, financialClubInfo) {
    return Vue.axios.put('financial-club', { financialClubInfo })
      .then(({ data }) => {
        financialClubInfo.id = data.id

        commit('SET_FINANCIAL_CLUB_INFO', financialClubInfo)

        if (financialClubInfo.newPhoto) {
          dispatch('loadFinancialClubPhoto', { formData: financialClubInfo.newPhoto })
        }
      })
  },
  // photo
  loadFinancialClubPhoto ({ commit }, { formData }) {
    return Vue.axios.post('financial-club/change-photo', formData)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/financialClubInfo.js